<template>
  <div class="analysis-list">
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label for="a_name">路段:</label>
          <input
            class="form-control"
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for="a_name">时间:</label>
          <el-date-picker
            type="datetimerange"
           
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </div>
        <div class="form-group other">
          <span class="search_btn">
            <button type="button" class="btn btn-primary" id="search_btn">
              查询
            </button>
          </span>
        </div>
      </form>
    </div>
    <div class="configure-right">
      <div id="myChart" style="width: 100%; height: 400px"></div>
    </div>
  </div>
</template>

<script>


export default {
  name:'analysis-chart',
  data() {
    return {
      search: {
        propertyId: null,
      },

      myChart: {
      xAxis: {
        type: 'category',
        data: ['0', '1', '3', '4', '5', '6', '7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24']
    },
    yAxis: {
        type: 'value'
    },
    series: [{
        data: [150, 230, 224, 218, 135, 147, 260,150, 230, 224, 218, 135, 147, 260,150, 230, 224, 218, 135, 147, 700,150, 230, 1000, 218],
        type: 'line'
    }]
      },

      tableListData: {},
    };
  },
  methods: {
    formatData: function(value) {
      if (!value) return "";
      return parseInt(value)
        .toString()
        .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
    },
  
  },
  mounted() {
     let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption(this.myChart, true);
  },
};
</script>

<style scoped>

#myChart {
  padding-top: 20px;
  padding-left: -2%;
}


</style>
